// DealType — the deal-shape dimension of certified-template lookup. Drives
// TemplateRepositoryPort.findByDealType.
import { z } from "zod";
export const DealTypeSchema = z.enum([
    "feature_film",
    "tv_series",
    "streaming",
    "documentary",
    "commercial",
    "short_form",
]);
export const DEAL_TYPES = DealTypeSchema.options;
//# sourceMappingURL=DealType.js.map